import BaseStore from './baseStore'
import { TYPES } from '../actions/adActions'
import { queryString } from '../../utils/window'
import { TYPES as SLIDESHOW_TYPES } from '../actions/slideshowActions'
import { getCountryCode } from '../../providers/geolocationProvider'

// when set to true, COUNTRY_CODES_TO_REFRESH_ADS_IN_SLIDESHOW is ignored
const SHOULD_REFRESH_ADS_IN_ALL_COUNTRY_CODES = true
// CountryCode list source: http://dev.maxmind.com/geoip/legacy/codes/iso3166/
const COUNTRY_CODES_TO_REFRESH_ADS_IN_SLIDESHOW = ['in', 'ar', 'th', 'mx']
// disables ad refreshed, ignoring all other settings
const SHOULD_NOT_REFRESH = false
const SLIDE_COUNT_BEFORE_ADS_REFRESH = 3
const { adsDebugRefresh } = queryString
const EMPTY_SLOT_DIMENSIONS = [0, 0]
const EMPTY_SLOT_SIZES_OBJECT = { width: 0, height: 0 }

class AdStore extends BaseStore {
  constructor(options = {}) {
    super(options)
    this.merge({
      state: {
        shown: {},
        topSlotHeight: null,
        slidesChanged: 0,
      },
      adBlockDetected: null,
      shouldRefreshSlot: SHOULD_NOT_REFRESH,
    })
    if (SHOULD_REFRESH_ADS_IN_ALL_COUNTRY_CODES) {
      this.setAdRefreshPolicy(SHOULD_REFRESH_ADS_IN_ALL_COUNTRY_CODES)
    } else {
      getCountryCode()
        .then(this.setAdRefreshPolicyByCountryCode.bind(this))
        .catch(this.setAdRefreshPolicy.part(SHOULD_NOT_REFRESH))
    }
  }

  setAdRefreshPolicy(shouldRefreshAdsOnSlideChange) {
    adsDebugRefresh &&
      this.info(
        'Setting slideshow ad refresh policy. Refresh every',
        SLIDE_COUNT_BEFORE_ADS_REFRESH,
        'slides?',
        shouldRefreshAdsOnSlideChange
      )
    return this.merge({ shouldRefreshSlot: shouldRefreshAdsOnSlideChange }).emitChange()
  }

  setAdRefreshPolicyByCountryCode(countryCode) {
    adsDebugRefresh && this.info('current countryCode', countryCode)
    const shouldRefresh = COUNTRY_CODES_TO_REFRESH_ADS_IN_SLIDESHOW.includes(
      countryCode.toLowerCase()
    )
    return this.setAdRefreshPolicy(shouldRefresh)
  }

  routeAction(action) {
    const { type, adId, size, isEmpty } = action
    const ACTIONS = TYPES
    const SLIDESHOW_ACTIONS = SLIDESHOW_TYPES
    switch (type) {
      case ACTIONS.AD_BLOCK_DETECTION_FINISHED:
        return this.onAdBlockDetectionFinished(action.state.detected)
      case ACTIONS.SLOT_HIDE:
        this.state.shown[adId] = false
        return this.emitChange()
      case ACTIONS.SLOT_RENDERED:
        const topSlot = window.googletag.renderedAdsEvents.Top
        if (topSlot && !this.state.topSlotHeight) {
          let topSlotHeight = topSlot.isEmpty || !topSlot.size ? 0 : topSlot.size[1]
          this.state.topSlotHeight = !this.state.topSlotHeight ? topSlotHeight : 'auto'
        }
        this.state.shown[adId] = !isEmpty
        this.state[adId] = this.state[adId] || {}
        this.state[adId].adSize = size
        return this.emitChange(action)
      case SLIDESHOW_ACTIONS.START_SLIDE_CHANGE:
        this.state.slidesChanged += 1
        if (this.state.slidesChanged % SLIDE_COUNT_BEFORE_ADS_REFRESH === 0) {
          adsDebugRefresh &&
            this.info(
              'Calling emitChange({ event: { slideshowRefreshAction: true, }, })',
              this,
              this.state.slidesChanged
            )
          return this.emitChange({
            event: {
              slideshowRefreshAction: true,
            },
          })
        }
        return this
      case SLIDESHOW_ACTIONS.COMPLETE_SLIDE_CHANGE:
        return this.emitChange({
          event: {
            resetPageTargetingLimit: true,
          },
        })
      default:
        return this
    }
  }

  onAdBlockDetectionFinished(detected) {
    this.state.adBlockDetected = detected
    return this.emitChange()
  }

  get shouldRefreshSlot() {
    return !this.isAdblockPresent && this.state.shouldRefreshSlot
  }
  set shouldRefreshSlot(bool) {
    this.state.shouldRefreshSlot = bool
  }

  get isAdsEnabled() {
    return this.state.isAdsEnabled
  }
  set isAdsEnabled(isEnabled) {
    this.state.isAdsEnabled = isEnabled
  }

  get isAdblockPresent() {
    return this.state.adBlockDetected
  }

  get requestedAdsCount() {
    return Object.keys(this.state.shown).length
  }
}

const adStore = AdStore.create()

export { adStore, EMPTY_SLOT_DIMENSIONS, EMPTY_SLOT_SIZES_OBJECT }



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/adStore.js